import { defer } from 'react-router-dom'
import dayjs from 'dayjs'
import { logger, getQueryStringParamsFromStringUrl } from '$utils'
import { isAppStateReady } from 'src/state/store'
import useTimeclockStore from '../store'
import { getDateRangeFromQueryStringOrAppStore } from '../../../../common/helpers/queryString'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in PunchesByStaff loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in PunchesByStaff loader')

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getTimeClockins = useTimeclockStore
    .getState()
    .getTimeClockins(startDateTime, endDateTime, false)

  // The date range is extended up to tomorrow when the report period is in
  // the past, so the backend returns the remuneration timeline records that
  // were valid during the period plus the record that is active today. The
  // record active today is needed to know if the staff member is currently
  // linked to the venue.
  const tomorrow = dayjs().add(1, 'day')
  const staffMembersRangeEnd = endDateTime.isAfter(tomorrow)
    ? endDateTime
    : tomorrow

  const getStaffMembers = useTimeclockStore
    .getState()
    .getStaffMembers(
      undefined,
      startDateTime.format('YYYY-MM-DD'),
      staffMembersRangeEnd.format('YYYY-MM-DD')
    )

  const getPackages = useTimeclockStore.getState().getPackages()

  return defer({
    data: Promise.all([getTimeClockins, getStaffMembers, getPackages])
      .then(() => true)
      .catch((error) => {
        logger.error('Punches By Staff Promise.all error', error)
        return false
      }),
  })
}
